import { render, staticRenderFns } from "./CookiesInfo.vue?vue&type=template&id=e39a83ac&scoped=true&"
import script from "./CookiesInfo.vue?vue&type=script&lang=js&"
export * from "./CookiesInfo.vue?vue&type=script&lang=js&"
import style0 from "./CookiesInfo.vue?vue&type=style&index=0&id=e39a83ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39a83ac",
  null
  
)

export default component.exports